// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEdit_root__2yvq3","pencil":"IconEdit_pencil__3vCVR"};